import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

import AuthLayout from '../../shared/components/AuthLayout';
import Button from '../../shared/components/Button';
import VerificationCodeInput from '../../shared/components/VerificationCodeInput';
import loginImage from '../../assets/images/login.png';
import { AUTH_STACK } from '../../utils/screenNames';

/**
 * ResetPasswordWithEmail Page - Refactored with Tailwind CSS
 * User enters 6-digit verification code sent to their email
 */
function ResetPasswordWithEmail() {
  const navigate = useNavigate();
  const location = useLocation();
  const { email } = location?.state || {};

  const [verificationCode, setVerificationCode] = useState(new Array(6).fill(''));
  const [error, setError] = useState('');

  /**
   * Handle code submission
   */
  const handleSubmit = async () => {
    const code = verificationCode.join('');

    if (code.length !== 6) {
      setError('Please enter the complete 6-digit code');
      return;
    }

    setError('');

    // Navigate to update password page with code
    navigate(AUTH_STACK.UPDATE_PASSWORD, {
      state: {
        email: email,
        confirmationCode: code,
      },
    });
  };

  return (
    <div className="relative w-screen h-screen bg-app-bg">
      {/* Back Button */}
      {/* <button
        onClick={() => navigate(-1)}
        className="absolute top-4 left-4 md:top-6 md:left-6 z-20 flex items-center gap-2 text-app-text-secondary hover:text-[#FEFCEB] transition-colors"
      >
        <ArrowLeft className="w-5 h-5" />
        <span className="font-proxima text-sm">Back to login</span>
      </button> */}

      {/* Main Content */}
      <AuthLayout
        heroImage={loginImage}
        title="Check your inbox"
        subtitle={
          <>
            Enter the verification code we just sent to
            <br />
            <span className="text-clubbie-blue font-medium">{email}</span>
          </>
        }
      >
        {/* Verification Code Input */}
        <div className="w-full flex justify-center my-8">
          <VerificationCodeInput
            length={6}
            value={verificationCode}
            onChange={setVerificationCode}
            error={error}
          />
        </div>

        {/* Reset Password Button */}
        <Button
          variant="primary"
          size="lg"
          onClick={handleSubmit}
          className="w-full h-11 bg-[#00E7FF] mt-5 text-[#021529] rounded-full font-medium text-[15px] hover:opacity-50 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
          disabled={verificationCode.join('').length !== 6}
        >
          Reset Password
        </Button>

        {/* Back to Login Link */}
        <button
          onClick={() => navigate(AUTH_STACK.LOGIN_OPTIONS)}
          className="w-full text-center text-sm text-app-text-secondary hover:text-light-blue transition-colors font-proxima mt-4"
        >
          Back to login
        </button>
      </AuthLayout>
    </div>
  );
}

export default ResetPasswordWithEmail;
